<template>
  <div class="knowledge-detail">
    <div class="detail-head">
      <div class="detail-head__num">04</div>
      <div class="detail-head__title">知识点明细</div>
    </div>
    <div class="detail-tip" v-if="subjectId !== 1 && subjectId !== 3">
      <p>
        学习总次数较多的知识点是班级内基础比较薄弱的知识点，学习未掌握次数较多的知识点是班里同学们在学习过程中普遍出错较多的知识点;
      </p>
      <p>
        学后平均能力值较低的知识点和能力值提升较小的知识点，学生们在学习过程中应该是遇到了问题，建议着重关注这两类知识点;
      </p>
    </div>
    <div class="detail-tip" v-if="subjectId === 1">
      <p>
        学习总次数较多的知识点是班级内基础比较薄弱的知识点；
      </p>
      <p>
        客观题正答率较低的知识点，学生们在学习过程中应该是遇到了问题，建议着重关注这两类知识点；
      </p>
    </div>
    <div class="detail-tip" v-if="subjectId === 3">
      <p>
        学习总次数较多的知识点是班级内基础比较薄弱的知识点；
      </p>
      <p>
        主观题得分率较低的知识点，学生们在学习过程中应该是遇到了问题，建议着重关注这两类知识点；
      </p>
    </div>
    <!-- <div v-show="subjectId===1">
      <el-table
    :data="showTableList"
    style="width: 100%"
    >
     <div slot="empty" class="no-data">
      <EmptyContent/>
    </div>
    <el-table-column
      prop="tag_name"
      label="知识点名称"
    >
      <template slot-scope="scope">
        <div style="color: #1989FA;">
          {{scope.row.tag_name}}
        </div>
      </template>
    </el-table-column>
     <el-table-column
      prop="study_count"
      label="学习总次数"
      width="150"
      align="center"
      sortable>
       <template slot-scope="scope">
        <div>
         {{scope.row.study_count+'次'}}
        </div>
      </template>
    </el-table-column>
    <el-table-column
      prop="obj_score_ratio"
      label="客观题正答率"
      align="center"
      width="150"
      sortable
      >
       <template slot-scope="scope">
         <div
          v-if="scope.row.obj_score_ratio*100>=40
          &&scope.row.obj_score_ratio*100<70" style="color:#F99830">
            {{Math.round(scope.row.obj_score_ratio*100)}}%
          </div>
          <div v-else-if="scope.row.obj_score_ratio*100>=70" style="color:#67C23A">
          {{Math.round(scope.row.obj_score_ratio*100)}}%
          </div>
          <div v-else-if="scope.row.obj_score_ratio*100>=0
          &&scope.row.obj_score_ratio*100<=40" style="color:#F56C6C">
          {{Math.round(scope.row.obj_score_ratio*100)}}%
          </div>
          <div v-else>
            --
          </div>
      </template>
     </el-table-column>
    </el-table>
    </div>
    <div v-show="subjectId===3">
        <el-table
      :data="showTableList"
      style="width: 100%"

      >
      <div slot="empty" class="no-data">
        <EmptyContent/>
      </div>
      <el-table-column
        prop="tag_name"
        label="知识点名称"
      >
        <template slot-scope="scope">
          <div style="color: #1989FA;">
            {{scope.row.tag_name}}
          </div>
        </template>

      </el-table-column>
      <el-table-column
        prop="study_count"
        label="学习总次数"
        width="150"
        align="center"
        sortable>
        <template slot-scope="scope">
          <div>
          {{scope.row.study_count+'次'}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="subj_score_ratio"
        label="主观题得分率"
        align="center"
        width="150"
        sortable
        >
        <template slot-scope="scope">
          <div
            v-if="scope.row.subj_score_ratio*100>=40
            &&scope.row.subj_score_ratio*100<70" style="color:#F99830">
              {{Math.round(scope.row.subj_score_ratio*100)}}%
            </div>
            <div v-else-if="scope.row.subj_score_ratio*100>=70" style="color:#67C23A">
            {{Math.round(scope.row.subj_score_ratio*100)}}%
            </div>
             <div
             v-else-if="scope.row.subj_score_ratio*100>=0&&scope.row.subj_score_ratio*100<=40"
             style="color:#F56C6C">
          {{Math.round(scope.row.subj_score_ratio*100)}}%
          </div>
          <div v-else>
            --
          </div>
        </template>
      </el-table-column>
    </el-table>
    </div> -->
    <div>
    <el-table
    :data="showTableList"
    style="width: 100%"

    >
      <div slot="empty" class="no-data">
      <EmptyContent/>
    </div>
    <el-table-column
      prop="tag_name"
      label="知识点名称"
    >
      <template slot-scope="scope">
        <div style="color: #1989FA;">
          {{scope.row.tag_name}}
        </div>
      </template>

    </el-table-column>
      <el-table-column
      prop="avg_ability_before"
      label="学前平均掌握程度"
      align="center"
      width="160"
      sortable
      >
      <template slot-scope="scope">
          {{ Math.floor(scope.row.avg_ability_before*100) }}%
      </template>
    </el-table-column>
      <el-table-column
      prop="avg_ability_after"
      label="学后平均掌握程度"
      align="center"
      width="160"
      sortable
      >
      <template slot-scope="scope">
          {{ Math.floor(scope.row.avg_ability_after*100) }}%
      </template>
    </el-table-column>
      <el-table-column
      prop="avg_ability_change"
      label="掌握程度变化"
      width="150"
      align="center"
      sortable>
        <template slot-scope="scope">
        <div v-if="scope.row.avg_ability_change>0" style="color:#1ABF5F">
          {{'↑'+ Math.floor(scope.row.avg_ability_change *100) }}%
        </div>
        <div v-else-if="scope.row.avg_ability_change<0" style="color:#F2494A">
          {{'↓'+ Math.abs(scope.row.avg_ability_change)}}
        </div>
        <div v-else-if="scope.row.avg_ability_change=0" style="color:#606266">
          {{scope.row.avg_ability_change}}
        </div>
      </template>
    </el-table-column>
      <el-table-column
      prop="study_count"
      label="学习总次数"
      width="150"
      align="center"
      sortable>
      <template slot-scope="scope">
        <div>
          {{scope.row.study_count+'次'}}
        </div>
      </template>
    </el-table-column>
    <el-table-column
    prop="study_low_score_count"
      label="学习未掌握次数"
      align="center"
      width="150"
      sortable
      >
       <template slot-scope="scope">
        <div>
          {{scope.row.study_low_score_count+'次'}}
        </div>
      </template>
    </el-table-column>
    </el-table>
    </div>
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="dataCount"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50]"
      :current-page="currentPage"
      @size-change="sizeChange"
      @current-change="currentChange"
    />
  </div>
</template>

<script>
import EmptyContent from '@/views/pt/components/empty-content.vue';

export default {
  name: 'KnowledgeDetail',
  components: {
    EmptyContent,
  },
  props: {
    subjectId: {
      default: 2,
      type: Number,
    },
    detailList: {
      default: () => [],
      type: Array,
    },
    dataCount: {
      default: 0,
      type: Number,
    },
  },
  data() {
    return {
      showTableList: [],
      currentPage: 1,
      pageSize: 10,
    };
  },
  watch: {
    detailList() {
      this.showTableList = this.detailList;
    },
    subjectId() {
      this.showTableList = this.detailList;
    },
  },
  methods: {
    sizeChange(v) { // 每页条数
      this.currentPage = 1;
      this.pageSize = v;
      this.$emit('sizeChange', this.pageSize);
    },
    currentChange(v) { // 当前页
      // this.currentPage = v;
      this.$emit('currentChange', v);
    },
  },
};
</script>

<style lang="scss" scoped>
.knowledge-detail{
  .detail-head{
    display: flex;
    align-items: center;
    margin-bottom:27px ;
    &__num{
      font-size: 22px;

      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      margin-right: 14px;
      background:url('~@/views/pt/images/class_bg.png');
      background-size:cover;
      width:38px;
      height:29px;
      text-align: center;
    }
    &__title{
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
    }
     &__info{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(17, 31, 44, 0.6);
    }
  }
  .detail-tip{
    height: 113px;
    margin-bottom: 24px;
    background:
    linear-gradient(180deg, rgba(226, 245, 255, 0.32) 0%, rgba(206, 238, 255, 0.33) 100%);
    border-radius: 8px;
    // opacity: 0.64;
    border: 2px dashed #E3F2FFFF;
    p:first-child{
      margin:24px 0 18px 40px ;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(17, 31, 44, 0.8);
      position: relative;
      &::before{
        content: '';
        width: 5px;
        height: 5px;
        background: rgba(17, 31, 44, 0.77);
        border-radius: 50%;
        left: -8px;
        top: 7px;
        position: absolute;
      }
    }
     p:last-child{
      margin-left:40px ;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(17, 31, 44, 0.8);
      position: relative;
      &::before{
        content: '';
        width: 5px;
        height: 5px;
        background: rgba(17, 31, 44, 0.77);
        border-radius: 50%;
        left: -8px;
        top: 7px;
        position: absolute;
      }
    }
  }
}
::v-deep {
  .el-table{
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #606266;
    .el-table__header th {
    background-color: #F0F2F5;;
    }
  }
  .el-pagination {
    margin-top: 20px;
    display: flex;
    width: calc(100% - 64px);
    & .btn-prev {
      margin-left: auto;
    }
  }
}
</style>
